import React, { useState } from 'react';
import { Coffee } from 'lucide-react';
import QuizModal from './Quiz/QuizModal';
import ShareButton from './ShareButton';

export default function SignUp() {
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  return (
    <section id="signup" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        {[...Array(6)].map((_, i) => (
          <Coffee
            key={i}
            className="absolute text-white/20 animate-float"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 60 + 40}px`,
              height: `${Math.random() * 60 + 40}px`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${Math.random() * 4 + 4}s`,
              transform: `rotate(${Math.random() * 360}deg)`,
              opacity: 0.8
            }}
          />
        ))}
        <div className="absolute inset-0 bg-[#132947]/80" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mt-8">
            <p className="text-white/80 mb-4">Already a Bond member? Help us grow the community!</p>
            <ShareButton variant="secondary" size="large" />
          </div>

          <div className="mt-12 grid md:grid-cols-4 gap-6 text-center">
            <div className="space-y-2">
              <div className="text-3xl">🕊️</div>
              <div className="text-white font-semibold">Light Roast</div>
              <div className="text-white/60 text-sm">Bright & Fruity</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl">🌿</div>
              <div className="text-white font-semibold">Medium Roast</div>
              <div className="text-white/60 text-sm">Balanced & Smooth</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl">🌋</div>
              <div className="text-white font-semibold">Dark Roast</div>
              <div className="text-white/60 text-sm">Rich & Bold</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl">🚀</div>
              <div className="text-white font-semibold">Espresso</div>
              <div className="text-white/60 text-sm">Intense & Concentrated</div>
            </div>
          </div>
        </div>
      </div>

      <QuizModal isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
    </section>
  );
}